export default __webpack_public_path__ + "static/media/i8.9d7fca3d.png";